import React from 'react';
import BaseCell from './BaseCell';
import { formatDate } from 'shared/../helpers/date';

// This component always ignores value's timezone

const DateCell = ({
  date, formatMethod = formatDate, ...props
}) => {
  const displayValue = date ? formatMethod(date) : null;
  return <BaseCell {...props}>{displayValue}</BaseCell>;
};

export default DateCell;
